import { render, staticRenderFns } from "./refundTax.vue?vue&type=template&id=38076fd0&scoped=true&"
import script from "./refundTax.vue?vue&type=script&lang=js&"
export * from "./refundTax.vue?vue&type=script&lang=js&"
import style0 from "./refundTax.vue?vue&type=style&index=0&id=38076fd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38076fd0",
  null
  
)

export default component.exports